!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.InfiniteCarousel = t(require("react")) : e.InfiniteCarousel = t(e.React);
}(self, function (t) {
  return function () {
    var n = {
        807: function _(e) {
          var t = !("undefined" == typeof window || !window.document || !window.document.createElement);
          e.exports = t;
        },
        352: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
          var o = n(537),
            t = n.n(o),
            o = n(645),
            t = n.n(o)()(t());
          t.push([e.id, ".InfiniteCarousel {\n  position: relative;\n}\n\n.InfiniteCarouselFrame {\n  width: 100%;\n  overflow: hidden;\n}\n\n.InfiniteCarouselScrollTrack {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n  overflow: -moz-scrollbars-none;\n  -webkit-box-sizing: border-box;\n}\n\n.InfiniteCarouselScrollTrack::-webkit-scrollbar {\n  display: none;\n}\n\n.InfiniteCarouselSlide img {\n  width: 100%;\n}\n\n.InfiniteCarouselPaging {\n  position: absolute;\n  left: 50%;\n  bottom: -60px;\n  padding: 0;\n  transform: translateX(-20%);\n  font-family: Arial;\n  letter-spacing: 2px;\n  color: #888;\n}\n\n.InfiniteCarouselDots {\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  padding: 0;\n  transform: translateX(-50%);\n}\n\n.InfiniteCarouselDot {\n  display: inline-block;\n  list-style: none;\n  margin: 0 5px;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.InfiniteCarouselDotIcon {\n  display: block;\n  background-color: #e5e5e5;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.InfiniteCarouselDotActiveIcon {\n  background-color: #48799a;\n}\n\n.InfiniteCarouselArrow {\n  display: block;\n  background: none;\n  border: none;\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  outline: none;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.InfiniteCarouselArrowPrev {\n  left: 15px;\n  right: auto;\n}\n\n.InfiniteCarouselArrowNext {\n  left: auto;\n  right: 15px;\n}\n\n.InfiniteCarouselArrowIcon {\n  display: inline-block;\n  padding: 10px;\n  border: solid #e5e5e5;\n  border-width: 0 5px 5px 0;\n}\n\n.InfiniteCarouselArrowNextIcon {\n  transform: rotate(-45deg);\n}\n\n.InfiniteCarouselArrowPrevIcon {\n  transform: rotate(135deg);\n}\n", "", {
            version: 3,
            sources: ["webpack://./src/components/InfiniteCarousel.css"],
            names: [],
            mappings: "AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B",
            sourcesContent: [".InfiniteCarousel {\n  position: relative;\n}\n\n.InfiniteCarouselFrame {\n  width: 100%;\n  overflow: hidden;\n}\n\n.InfiniteCarouselScrollTrack {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n  overflow: -moz-scrollbars-none;\n  -webkit-box-sizing: border-box;\n}\n\n.InfiniteCarouselScrollTrack::-webkit-scrollbar {\n  display: none;\n}\n\n.InfiniteCarouselSlide img {\n  width: 100%;\n}\n\n.InfiniteCarouselPaging {\n  position: absolute;\n  left: 50%;\n  bottom: -60px;\n  padding: 0;\n  transform: translateX(-20%);\n  font-family: Arial;\n  letter-spacing: 2px;\n  color: #888;\n}\n\n.InfiniteCarouselDots {\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  padding: 0;\n  transform: translateX(-50%);\n}\n\n.InfiniteCarouselDot {\n  display: inline-block;\n  list-style: none;\n  margin: 0 5px;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.InfiniteCarouselDotIcon {\n  display: block;\n  background-color: #e5e5e5;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.InfiniteCarouselDotActiveIcon {\n  background-color: #48799a;\n}\n\n.InfiniteCarouselArrow {\n  display: block;\n  background: none;\n  border: none;\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  outline: none;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.InfiniteCarouselArrowPrev {\n  left: 15px;\n  right: auto;\n}\n\n.InfiniteCarouselArrowNext {\n  left: auto;\n  right: 15px;\n}\n\n.InfiniteCarouselArrowIcon {\n  display: inline-block;\n  padding: 10px;\n  border: solid #e5e5e5;\n  border-width: 0 5px 5px 0;\n}\n\n.InfiniteCarouselArrowNextIcon {\n  transform: rotate(-45deg);\n}\n\n.InfiniteCarouselArrowPrevIcon {\n  transform: rotate(135deg);\n}\n"],
            sourceRoot: ""
          }]);
          var r = t;
        },
        645: function _(e) {
          "use strict";

          e.exports = function (o) {
            var u = [];
            return u.toString = function () {
              return this.map(function (e) {
                var t = "",
                  n = void 0 !== e[5];
                return e[4] && (t += "@supports (".concat(e[4], ") {")), e[2] && (t += "@media ".concat(e[2], " {")), n && (t += "@layer".concat(0 < e[5].length ? " ".concat(e[5]) : "", " {")), t += o(e), n && (t += "}"), e[2] && (t += "}"), e[4] && (t += "}"), t;
              }).join("");
            }, u.i = function (e, t, n, o, r) {
              "string" == typeof e && (e = [[null, e, void 0]]);
              var i = {};
              if (n) for (var s = 0; s < this.length; s++) {
                var a = this[s][0];
                null != a && (i[a] = !0);
              }
              for (var l = 0; l < e.length; l++) {
                var c = [].concat(e[l]);
                n && i[c[0]] || (void 0 !== r && (void 0 === c[5] || (c[1] = "@layer".concat(0 < c[5].length ? " ".concat(c[5]) : "", " {").concat(c[1], "}")), c[5] = r), t && (c[2] && (c[1] = "@media ".concat(c[2], " {").concat(c[1], "}")), c[2] = t), o && (c[4] ? (c[1] = "@supports (".concat(c[4], ") {").concat(c[1], "}"), c[4] = o) : c[4] = "".concat(o)), u.push(c));
              }
            }, u;
          };
        },
        537: function _(e) {
          "use strict";

          e.exports = function (e) {
            var t = e[1],
              n = e[3];
            if (!n) return t;
            if ("function" != typeof btoa) return [t].join("\n");
            var o = btoa(unescape(encodeURIComponent(JSON.stringify(n)))),
              e = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(o),
              o = "/*# ".concat(e, " */"),
              e = n.sources.map(function (e) {
                return "/*# sourceURL=".concat(n.sourceRoot || "").concat(e, " */");
              });
            return [t].concat(e).concat([o]).join("\n");
          };
        },
        988: function _(e, t, n) {
          var o = n(755),
            r = n(665).each;
          function i(e, t) {
            this.query = e, this.isUnconditional = t, this.handlers = [], this.mql = window.matchMedia(e);
            var n = this;
            this.listener = function (e) {
              n.mql = e.currentTarget || e, n.assess();
            }, this.mql.addListener(this.listener);
          }
          i.prototype = {
            constuctor: i,
            addHandler: function addHandler(e) {
              e = new o(e);
              this.handlers.push(e), this.matches() && e.on();
            },
            removeHandler: function removeHandler(n) {
              var o = this.handlers;
              r(o, function (e, t) {
                if (e.equals(n)) return e.destroy(), !o.splice(t, 1);
              });
            },
            matches: function matches() {
              return this.mql.matches || this.isUnconditional;
            },
            clear: function clear() {
              r(this.handlers, function (e) {
                e.destroy();
              }), this.mql.removeListener(this.listener), this.handlers.length = 0;
            },
            assess: function assess() {
              var t = this.matches() ? "on" : "off";
              r(this.handlers, function (e) {
                e[t]();
              });
            }
          }, e.exports = i;
        },
        177: function _(e, t, n) {
          var r = n(988),
            n = n(665),
            i = n.each,
            s = n.isFunction,
            a = n.isArray;
          function o() {
            if (!window.matchMedia) throw new Error("matchMedia not present, legacy browsers require a polyfill");
            this.queries = {}, this.browserIsIncapable = !window.matchMedia("only all").matches;
          }
          o.prototype = {
            constructor: o,
            register: function register(t, e, n) {
              var o = this.queries,
                n = n && this.browserIsIncapable;
              return o[t] || (o[t] = new r(t, n)), s(e) && (e = {
                match: e
              }), a(e) || (e = [e]), i(e, function (e) {
                s(e) && (e = {
                  match: e
                }), o[t].addHandler(e);
              }), this;
            },
            unregister: function unregister(e, t) {
              var n = this.queries[e];
              return n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])), this;
            }
          }, e.exports = o;
        },
        755: function _(e) {
          function t(e) {
            (this.options = e).deferSetup || this.setup();
          }
          t.prototype = {
            constructor: t,
            setup: function setup() {
              this.options.setup && this.options.setup(), this.initialised = !0;
            },
            on: function on() {
              this.initialised || this.setup(), this.options.match && this.options.match();
            },
            off: function off() {
              this.options.unmatch && this.options.unmatch();
            },
            destroy: function destroy() {
              this.options.destroy ? this.options.destroy() : this.off();
            },
            equals: function equals(e) {
              return this.options === e || this.options.match === e;
            }
          }, e.exports = t;
        },
        665: function _(e) {
          e.exports = {
            isFunction: function isFunction(e) {
              return "function" == typeof e;
            },
            isArray: function isArray(e) {
              return "[object Array]" === Object.prototype.toString.apply(e);
            },
            each: function each(e, t) {
              for (var n = 0, o = e.length; n < o && !1 !== t(e[n], n); n++);
            }
          };
        },
        974: function _(e, t, n) {
          n = n(177);
          e.exports = new n();
        },
        973: function _(e, t, n) {
          function r(o) {
            var r = "",
              i = Object.keys(o);
            return i.forEach(function (e, t) {
              var n = o[e];
              e = s(e), a(e) && "number" == typeof n && (n += "px"), r += !0 === n ? e : !1 === n ? "not " + e : "(" + e + ": " + n + ")", t < i.length - 1 && (r += " and ");
            }), r;
          }
          var s = n(169),
            a = function a(e) {
              return /[height|width]$/.test(e);
            };
          e.exports = function (n) {
            var o = "";
            return "string" == typeof n ? n : n instanceof Array ? (n.forEach(function (e, t) {
              o += r(e), t < n.length - 1 && (o += ", ");
            }), o) : r(n);
          };
        },
        703: function _(e, t, n) {
          "use strict";

          var s = n(414);
          function o() {}
          function r() {}
          r.resetWarningCache = o, e.exports = function () {
            function e(e, t, n, o, r, i) {
              if (i !== s) {
                i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw i.name = "Invariant Violation", i;
              }
            }
            function t() {
              return e;
            }
            var n = {
              array: e.isRequired = e,
              bool: e,
              func: e,
              number: e,
              object: e,
              string: e,
              symbol: e,
              any: e,
              arrayOf: t,
              element: e,
              elementType: e,
              instanceOf: t,
              node: e,
              objectOf: t,
              oneOf: t,
              oneOfType: t,
              shape: t,
              exact: t,
              checkPropTypes: r,
              resetWarningCache: o
            };
            return n.PropTypes = n;
          };
        },
        697: function _(e, t, n) {
          e.exports = n(703)();
        },
        414: function _(e) {
          "use strict";

          e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        456: function _(e, t, n) {
          var o = n(807),
            r = o && n(974),
            i = n(973),
            n = {
              media: function media(e, t) {
                e = i(e), "function" == typeof t && (t = {
                  match: t
                }), o && r.register(e, t), this._responsiveMediaHandlers || (this._responsiveMediaHandlers = []), this._responsiveMediaHandlers.push({
                  query: e,
                  handler: t
                });
              },
              componentWillUnmount: function componentWillUnmount() {
                this._responsiveMediaHandlers && this._responsiveMediaHandlers.forEach(function (e) {
                  o && r.unregister(e.query, e.handler);
                });
              }
            };
          e.exports = n;
        },
        169: function _(e) {
          e.exports = function (e) {
            return e.replace(/[A-Z]/g, function (e) {
              return "-" + e.toLowerCase();
            }).toLowerCase();
          };
        },
        379: function _(e) {
          "use strict";

          var c = [];
          function u(e) {
            for (var t = -1, n = 0; n < c.length; n++) if (c[n].identifier === e) {
              t = n;
              break;
            }
            return t;
          }
          function a(e, t) {
            for (var n = {}, o = [], r = 0; r < e.length; r++) {
              var i = e[r],
                s = t.base ? i[0] + t.base : i[0],
                a = n[s] || 0,
                l = "".concat(s, " ").concat(a);
              n[s] = a + 1;
              a = u(l), i = {
                css: i[1],
                media: i[2],
                sourceMap: i[3],
                supports: i[4],
                layer: i[5]
              };
              -1 !== a ? (c[a].references++, c[a].updater(i)) : (i = function (t, e) {
                var n = e.domAPI(e);
                return n.update(t), function (e) {
                  e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap && e.supports === t.supports && e.layer === t.layer || n.update(t = e) : n.remove();
                };
              }(i, t), t.byIndex = r, c.splice(r, 0, {
                identifier: l,
                updater: i,
                references: 1
              })), o.push(l);
            }
            return o;
          }
          e.exports = function (e, i) {
            var s = a(e = e || [], i = i || {});
            return function (e) {
              e = e || [];
              for (var t = 0; t < s.length; t++) {
                var n = u(s[t]);
                c[n].references--;
              }
              for (var e = a(e, i), o = 0; o < s.length; o++) {
                var r = u(s[o]);
                0 === c[r].references && (c[r].updater(), c.splice(r, 1));
              }
              s = e;
            };
          };
        },
        569: function _(e) {
          "use strict";

          var n = {};
          e.exports = function (e, t) {
            if (!(e = function (e) {
              if (void 0 === n[e]) {
                var t = document.querySelector(e);
                if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
                  t = t.contentDocument.head;
                } catch (e) {
                  t = null;
                }
                n[e] = t;
              }
              return n[e];
            }(e))) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            e.appendChild(t);
          };
        },
        216: function _(e) {
          "use strict";

          e.exports = function (e) {
            var t = document.createElement("style");
            return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
          };
        },
        565: function _(e, t, n) {
          "use strict";

          e.exports = function (e) {
            var t = n.nc;
            t && e.setAttribute("nonce", t);
          };
        },
        795: function _(e) {
          "use strict";

          e.exports = function (t) {
            var n = t.insertStyleElement(t);
            return {
              update: function update(e) {
                !function (e, t, n) {
                  var o = "";
                  n.supports && (o += "@supports (".concat(n.supports, ") {")), n.media && (o += "@media ".concat(n.media, " {"));
                  var r = void 0 !== n.layer;
                  r && (o += "@layer".concat(0 < n.layer.length ? " ".concat(n.layer) : "", " {")), o += n.css, r && (o += "}"), n.media && (o += "}"), n.supports && (o += "}"), (n = n.sourceMap) && "undefined" != typeof btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), " */")), t.styleTagTransform(o, e, t.options);
                }(n, t, e);
              },
              remove: function remove() {
                var e;
                null !== (e = n).parentNode && e.parentNode.removeChild(e);
              }
            };
          };
        },
        589: function _(e) {
          "use strict";

          e.exports = function (e, t) {
            if (t.styleSheet) t.styleSheet.cssText = e;else {
              for (; t.firstChild;) t.removeChild(t.firstChild);
              t.appendChild(document.createTextNode(e));
            }
          };
        },
        104: function _(e) {
          var n = "undefined" != typeof process && process.pid ? process.pid.toString(36) : "";
          function o() {
            var e = Date.now(),
              t = o.last || e;
            return o.last = t < e ? e : t + 1;
          }
          e.exports = e.exports.default = function (e, t) {
            return (e || "") + "" + n + o().toString(36) + (t || "");
          }, e.exports.process = function (e, t) {
            return (e || "") + n + o().toString(36) + (t || "");
          }, e.exports.time = function (e, t) {
            return (e || "") + o().toString(36) + (t || "");
          };
        },
        787: function _(e) {
          "use strict";

          e.exports = t;
        }
      },
      o = {};
    function T(e) {
      var t = o[e];
      if (void 0 !== t) return t.exports;
      t = o[e] = {
        id: e,
        exports: {}
      };
      return n[e](t, t.exports, T), t.exports;
    }
    T.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return T.d(t, {
        a: t
      }), t;
    }, T.d = function (e, t) {
      for (var n in t) T.o(t, n) && !T.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }, T.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, T.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var k = {};
    return function () {
      "use strict";

      T.r(k), T.d(k, {
        default: function _default() {
          return I;
        }
      });
      var g = T(787),
        f = T.n(g),
        e = T(697),
        t = T.n(e),
        u = T(456),
        n = T(104),
        d = T.n(n);
      function A() {
        return "ontouchstart" in document.documentElement;
      }
      function i(e, t) {
        return e - t;
      }
      var o = T(379),
        r = T.n(o),
        s = T(795),
        a = T.n(s),
        l = T(569),
        c = T.n(l),
        e = T(565),
        n = T.n(e),
        o = T(216),
        s = T.n(o),
        l = T(589),
        e = T.n(l),
        o = T(352),
        l = {};
      l.styleTagTransform = e(), l.setAttributes = n(), l.insert = c().bind(null, "head"), l.domAPI = a(), l.insertStyleElement = s();
      r()(o.Z, l), o.Z && o.Z.locals && o.Z.locals;
      o = function o(e) {
        var t = e.carouselName,
          n = e.next,
          o = e.onClick,
          r = n ? "InfiniteCarouselArrowNext" : "InfiniteCarouselArrowPrev",
          e = n ? "InfiniteCarouselArrowNextIcon" : "InfiniteCarouselArrowPrevIcon",
          r = "".concat("InfiniteCarouselArrow", " ").concat(r),
          e = "".concat("InfiniteCarouselArrowIcon", " ").concat(e),
          n = "".concat(t, "-button-").concat(n ? "next" : "previous");
        return f().createElement("button", {
          name: n,
          "data-testid": n,
          className: r,
          onClick: o,
          type: "button"
        }, f().createElement("i", {
          className: e
        }));
      };
      o.propTypes = {
        carouselName: t().string.isRequired,
        next: t().bool,
        onClick: t().func.isRequired
      }, o.defaultProps = {
        next: !0
      };
      var h = o;
      o = function o(e) {
        for (var t, n, o = e.carouselName, r = e.numberOfDots, i = e.activePage, s = e.onClick, a = [], l = 0; l < r; l += 1) t = "InfiniteCarouselDotIcon ".concat(l === i ? "InfiniteCarouselDotActiveIcon" : ""), n = "".concat(o, "-dots-").concat(l), a.push(f().createElement("button", {
          name: n,
          "data-testid": n,
          className: "InfiniteCarouselDot",
          "data-index": l,
          key: l + 1,
          onClick: s,
          type: "button"
        }, f().createElement("i", {
          className: t
        })));
        return f().createElement("ul", {
          "data-testid": "".concat(o, "-dots"),
          className: "InfiniteCarouselDots"
        }, a);
      };
      o.propTypes = {
        carouselName: t().string.isRequired,
        numberOfDots: t().number.isRequired,
        activePage: t().number.isRequired,
        onClick: t().func.isRequired
      };
      var m = o;
      function p(e) {
        return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function v(e) {
        return function (e) {
          if (Array.isArray(e)) return y(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          if (e) {
            if ("string" == typeof e) return y(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(e, t) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function y(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      function b(t, e) {
        var n,
          o = Object.keys(t);
        return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.push.apply(o, n)), o;
      }
      function C(o) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? b(Object(r), !0).forEach(function (e) {
            var t, n;
            t = o, e = r[n = e], n in t ? Object.defineProperty(t, n, {
              value: e,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[n] = e;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : b(Object(r)).forEach(function (e) {
            Object.defineProperty(o, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }
        return o;
      }
      function w(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function S(e, t) {
        return (S = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function E(n) {
        var o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = x(n);
          return function (e, t) {
            {
              if (t && ("object" === p(t) || "function" == typeof t)) return t;
              if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            }
            return function (e) {
              if (void 0 !== e) return e;
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }(e);
          }(this, o ? (e = x(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments));
        };
      }
      function x(e) {
        return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      o = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && S(e, t);
        }(r, g.Component);
        var e,
          t,
          n,
          o = E(r);
        function r(e) {
          var h;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), (h = o.call(this, e)).setupBreakpointSettings = function () {
            var e = h.props,
              s = e.children,
              a = e.scrollOnDevice,
              e = e.breakpoints,
              l = h.state.scrollOnDeviceProps,
              t = e.map(function (e) {
                return e.breakpoint;
              }),
              c = {};
            e.forEach(function (e) {
              c[e.breakpoint] = e.settings;
            }), 0 < t.length && (t.sort(i), t.forEach(function (o, e) {
              var r,
                i = (r = 0 === e ? 0 : t[e - 1], o - 1),
                e = {
                  minWidth: r,
                  maxWidth: i
                };
              (0, u.media)(e, function () {
                var e = a && A() ? l : {},
                  t = C(C(C(C({}, h.defaultProps), h.props), c[o]), e),
                  n = h.getChildrenList(s, t.slidesToShow),
                  e = n.map(function (e) {
                    return d()("slide-");
                  });
                h.setState({
                  settings: t,
                  children: n,
                  slideUniqueIds: e,
                  lowerBreakpoint: r,
                  higherBreakpoint: i
                }, h.setDimensions);
              });
            }), t.reverse(), e = {
              minWidth: t[0]
            }, (0, u.media)(e, function () {
              var e = a && A() ? l : {},
                t = C(C(C({}, h.defaultProps), h.props), e),
                n = h.getChildrenList(s, t.slidesToShow),
                e = n.map(function (e) {
                  return d()("slide-");
                });
              h.setState({
                settings: t,
                children: n,
                slideUniqueIds: e,
                lowerBreakpoint: void 0,
                higherBreakpoint: void 0
              }, h.setDimensions);
            }));
          }, h.getSideSize = function (e, t, n) {
            var o = h.state.settings,
              r = o.incrementalSides,
              o = o.sideSize;
            return void 0 !== e && void 0 !== t && r ? 50 * (n - e) / (t - e) / 100 : o;
          }, h.setDimensions = function () {
            var e,
              t = h.state,
              n = t.settings,
              o = t.lowerBreakpoint,
              r = t.higherBreakpoint,
              i = t.children,
              s = t.currentIndex,
              a = t.autoCycleTimer,
              l = h.props,
              c = l.children,
              u = l.scrollOnDevice && A(),
              d = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
              p = h.getSideSize(o, r, d),
              f = g.Children.count(c),
              t = u ? f : g.Children.count(i),
              o = ((l = h.frame).getBoundingClientRect().width || l.offsetWidth || 0) / (h.props.showSides ? n.slidesToShow + 2 * p : n.slidesToShow) - 2 * n.slidesSpacing,
              r = c.length,
              d = Math.ceil(s / n.slidesToShow),
              l = Math.ceil(r / n.slidesToShow),
              n = r > n.slidesToShow ? l : 1,
              l = n <= 1,
              s = l || u ? (e = i.map(function (e, t) {
                return t;
              }), [].concat(e)) : (e = h.getLazyLoadedIndexes(c, s), h.getVisibleIndexes(c, s));
            clearInterval(a), h.setState({
              activePage: d,
              childrenCount: f,
              slidesCount: t,
              slidesWidth: o,
              slidePages: n,
              singlePage: l,
              lazyLoadedList: e,
              visibleSlideList: s,
              sideSize: p,
              autoCycleTimer: null
            }, function () {
              h.playAutoCycle();
            });
          }, h.getVisibleIndexes = function (e, t) {
            var n = [],
              o = h.state.settings,
              r = o.showSides ? 1 : 0,
              i = e.length + o.slidesToShow + r;
            if (0 === t) for (var s = i + o.slidesToShow - 1, a = i; a <= s; a += 1) n.push(a);
            if (i = 0 + r, t === e.length - o.slidesToShow) {
              s = i + o.slidesToShow - 1;
              for (var l = i; l <= s; l += 1) n.push(l);
            }
            s = (i = t + o.slidesToShow + r) + (o.slidesToShow - 1);
            for (var c = i; c <= s; c += 1) n.push(c);
            return n;
          }, h.getLazyLoadedIndexes = function (e, t) {
            var n = h.state.lazyLoadedList,
              o = h.state.settings,
              r = o.showSides ? 1 : 0,
              i = [].concat(n),
              s = e.length + o.slidesToShow + r;
            if (0 === t && n.indexOf(s) < 0) for (var a = s + o.slidesToShow + r - 1, l = s; l <= a; l += 1) i.push(l);
            var c = t === e.length - o.slidesToShow,
              e = i.indexOf(s = 0) < 0;
            if (c && e) {
              a = s + o.slidesToShow + r - 1;
              for (var u = s; u <= a; u += 1) i.push(u);
            }
            a = (s = t + o.slidesToShow + r) + (o.slidesToShow - 1), o.showSides && (--s, a += 1);
            for (var d = s; d <= a; d += 1) n.indexOf(d) < 0 && i.push(d);
            return i;
          }, h.getChildrenList = function (e, t) {
            var n = h.props,
              o = n.scrollOnDevice,
              n = n.showSides;
            return Array.isArray(e) ? o && A() ? e : e.length > t && n ? [].concat(v(e.slice(e.length - t - 1, e.length)), v(e), v(e.slice(0, t + 1))) : e.length > t ? [].concat(v(e.slice(e.length - t, e.length)), v(e), v(e.slice(0, t))) : e : [e];
          }, h.getTargetIndex = function (e, t) {
            var n = h.state,
              o = n.childrenCount,
              r = n.currentIndex,
              n = o % t;
            return e < 0 ? 0 === r ? o - t : 0 : o <= e ? 0 != n ? 0 : e - o : 0 != n && e === o - n ? e - (t - n) : e;
          }, h.onDotClick = function (e) {
            e.preventDefault();
            var t = h.state,
              n = t.settings,
              o = t.animating,
              r = t.autoCycleTimer,
              i = n.slidesToShow,
              t = n.autoCycle;
            o || (t && r && (clearInterval(r), h.setState({
              autoCycleTimer: null
            })), r = e.target.parentElement.getAttribute("data-index"), e = h.getTargetIndex(r * i, i), h.handleTrack(r * i, e), n.autoCycle && h.playAutoCycle());
          }, h.onWindowResized = function () {
            h.setDimensions();
          }, h.onMouseEnter = function () {
            var e = h.state.settings,
              t = e.autoCycle,
              e = e.pauseOnHover;
            t && e && h.pauseAutoCycle();
          }, h.onMouseOver = function () {
            var e = h.state.settings,
              t = e.autoCycle,
              e = e.pauseOnHover;
            t && e && h.pauseAutoCycle();
          }, h.onMouseLeave = function () {
            var e = h.state.settings,
              t = e.autoCycle,
              e = e.pauseOnHover;
            t && e && h.playAutoCycle();
          }, h.onSwipeStart = function (e) {
            var t = h.state.settings,
              n = t.swipe,
              t = t.draggable;
            if (!1 === n || "ontouchend" in document && !1 === n) return null;
            if (!1 === t && -1 !== e.type.indexOf("mouse")) return null;
            t = void 0 !== e.touches ? e.touches[0].pageX : e.clientX, e = void 0 !== e.touches ? e.touches[0].pageY : e.clientY;
            return h.setState({
              dragging: !0,
              touchObject: {
                startX: t,
                startY: e
              }
            }), !0;
          }, h.onSwipeMove = function (e) {
            var t,
              n,
              o,
              r = h.state,
              i = r.dragging,
              s = r.animating;
            i ? s || (t = void 0 !== e.touches ? e.touches[0].pageX : e.clientX, n = void 0 !== e.touches ? e.touches[0].pageY : e.clientY, o = h.state.touchObject, r = o.startX, i = t, s = o.startY, 0 != (r = (i = (i = Math.round(180 * Math.atan2(s - n, r - i) / Math.PI)) < 0 ? 360 - Math.abs(i) : i) <= 45 && 0 <= i || i <= 360 && 315 <= i ? 1 : 135 <= i && i <= 225 ? -1 : 0) && e.preventDefault(), i = Math.round(Math.sqrt(Math.pow(t - o.startX, 2))), h.setState({
              touchObject: {
                startX: o.startX,
                startY: o.startY,
                endX: t,
                endY: n,
                length: i,
                direction: r
              }
            })) : e.preventDefault();
          }, h.onSwipeEnd = function () {
            var e,
              t,
              n = h.state,
              o = n.touchObject,
              r = n.slidesWidth,
              i = n.autoCycleTimer,
              s = n.settings,
              a = n.currentIndex,
              n = o.length;
            0 !== n && r / 2 < n ? (s.autoCycle && i && (clearInterval(i), h.setState({
              autoCycleTimer: null
            })), 1 === o.direction ? (e = a + s.slidesToScroll, t = h.getTargetIndex(e, s.slidesToScroll)) : (e = a - s.slidesToScroll, t = h.getTargetIndex(e, s.slidesToScroll), e < 0 && 0 !== a && (e = 0)), h.handleTrack(e, t), s.autoCycle && h.playAutoCycle()) : h.setState({
              animating: !0,
              touchObject: {
                direction: -1 * o.direction
              }
            }, function () {
              setTimeout(function () {
                h.setState({
                  animating: !1,
                  dragging: !1,
                  touchObject: {
                    startX: 0,
                    startY: 0,
                    endX: 0,
                    endY: 0,
                    length: 0,
                    direction: -1
                  }
                });
              }, s.animationDuration);
            });
          }, h.getTrackStyles = function () {
            var e = h.state.settings,
              t = h.state,
              n = t.touchObject,
              o = t.singlePage,
              r = t.sideSize,
              i = t.animating,
              s = t.slidesWidth,
              a = t.slidesCount,
              l = t.currentIndex,
              t = s + 2 * e.slidesSpacing;
            t *= a + 2 * e.slidesToShow;
            a = s + 2 * e.slidesSpacing, s = e.showSides ? 1 : 0, s = a * (e.slidesToShow + s), i = i ? "transform ".concat(e.animationDuration, "ms ease") : "", n = s + a * l + (e.swipe && n.length ? n.length * n.direction : 0), r *= a;
            return e.showSides && (n -= r), {
              position: "relative",
              display: "block",
              width: o ? "100%" : t,
              height: "auto",
              padding: 0,
              transition: i,
              transform: o ? "none" : "translate(".concat(-n, "px, 0px)"),
              boxSizing: "border-box",
              MozBoxSizing: "border-box",
              marginLeft: o && e.showSides ? "".concat(r, "px") : "0px"
            };
          }, h.getScrollTrackStyles = {
            clear: "both",
            position: "relative",
            display: "block",
            width: "100%",
            height: "auto",
            padding: 0,
            boxSizing: "border-box",
            MozBoxSizing: "border-box"
          }, h.getSlideStyles = function (e) {
            var t = h.state,
              n = t.slidesWidth,
              o = t.settings,
              t = h.props.scrollOnDevice && A(),
              e = e ? "1" : o.sidesOpacity;
            return {
              position: "relative",
              float: t ? "none" : "left",
              display: "inline-block",
              width: Number.isNaN(n) ? 1 : n,
              height: "auto",
              margin: "0 ".concat(o.slidesSpacing, "px"),
              opacity: e
            };
          }, h.getFormatedChildren = function (e, i, s) {
            return g.Children.map(e, function (e, t) {
              var n = h.state,
                o = n.settings,
                r = n.slideUniqueIds,
                n = 0 <= s.indexOf(t);
              return !o.lazyLoad || 0 <= i.indexOf(t) ? f().createElement("li", {
                className: "InfiniteCarouselSlide",
                key: r[t],
                style: h.getSlideStyles(n)
              }, e) : f().createElement("li", {
                className: "InfiniteCarouselSlide",
                key: r[t],
                style: h.getSlideStyles(n)
              }, f().createElement("noscript", null, e), f().createElement("img", {
                alt: "placeholder",
                src: o.placeholderImageSrc
              }));
            });
          }, h.autoCycle = function () {
            var e = h.state,
              t = e.settings,
              e = e.currentIndex + t.slidesToScroll,
              t = h.getTargetIndex(e, t.slidesToScroll);
            h.handleTrack(e, t);
          }, h.playAutoCycle = function () {
            var e = h.state.settings;
            e.autoCycle && (e = setInterval(h.autoCycle, e.cycleInterval), h.setState({
              autoCycleTimer: e
            }));
          }, h.pauseAutoCycle = function () {
            var e = h.state.autoCycleTimer;
            e && (clearInterval(e), h.setState({
              autoCycleTimer: null
            }));
          }, h.handleTrack = function (e, t) {
            var n = h.props,
              o = n.children,
              r = n.onSlideChange,
              i = h.state.settings,
              s = Math.ceil(t / i.slidesToShow),
              a = h.getLazyLoadedIndexes(o, t),
              l = h.getVisibleIndexes(o, t),
              n = function n() {
                setTimeout(function () {
                  h.setState({
                    currentIndex: t,
                    animating: !1,
                    dragging: !1
                  });
                }, i.animationDuration);
              };
            e < 0 || e >= o.length ? h.setState({
              currentIndex: e,
              activePage: s,
              animating: !0,
              lazyLoadedList: a,
              visibleSlideList: l,
              touchObject: {
                startX: 0,
                startY: 0,
                endX: 0,
                endY: 0,
                length: 0,
                direction: -1
              }
            }, n) : h.setState({
              currentIndex: t,
              activePage: s,
              animating: !0,
              lazyLoadedList: a,
              visibleSlideList: l,
              dragging: !1,
              touchObject: {
                startX: 0,
                startY: 0,
                endX: 0,
                endY: 0,
                length: 0,
                direction: -1
              }
            }, function () {
              setTimeout(function () {
                h.setState({
                  animating: !1,
                  dragging: !1
                });
              }, i.animationDuration);
            }), r && r(s);
          }, h.moveToNext = function (e) {
            var t = h.props.onNextClick,
              n = h.state,
              o = n.animating,
              r = n.settings,
              i = n.currentIndex,
              n = n.autoCycleTimer;
            e.preventDefault(), t && t(e), o || (r.autoCycle && n && (clearInterval(n), h.setState({
              autoCycleTimer: null
            })), n = i + r.slidesToScroll, i = h.getTargetIndex(n, r.slidesToScroll), h.handleTrack(n, i), r.autoCycle && h.playAutoCycle());
          }, h.moveToPrevious = function (e) {
            var t = h.props.onPreviousClick,
              n = h.state,
              o = n.animating,
              r = n.settings,
              i = n.currentIndex,
              n = n.autoCycleTimer;
            e.preventDefault(), t && t(e), o || (r.autoCycle && n && (clearInterval(n), h.setState({
              autoCycleTimer: null
            })), o = i - r.slidesToScroll, n = h.getTargetIndex(o, r.slidesToScroll), h.handleTrack(o = o < 0 && 0 !== i ? 0 : o, n), r.autoCycle && h.playAutoCycle());
          }, h.getSettingsForScrollOnDevice = function () {
            var e = h.props.scrollOnDevice,
              t = h.state.scrollOnDeviceProps,
              t = e && A() ? C(C(C({}, h.defaultProps), h.props), t) : C(C({}, h.defaultProps), h.props);
            return t;
          }, h.init = function () {
            var e, t, n;
            0 < h.props.breakpoints.length ? h.setupBreakpointSettings() : (t = h.props.children, n = (e = h.getSettingsForScrollOnDevice()).slidesToShow, n = (t = h.getChildrenList(t, n)).map(function (e) {
              return d()("slide-");
            }), h.setState({
              children: t,
              slideUniqueIds: n,
              settings: e
            }, function () {
              h.setDimensions();
            }));
          }, h.storeFrameRef = function (e) {
            null !== e && (h.frame = e);
          }, h.state = {
            currentIndex: 0,
            activePage: 0,
            children: [],
            lazyLoadedList: [],
            visibleSlideList: [],
            childrenCount: 0,
            slidesCount: 0,
            slidesWidth: 1,
            slidePages: 1,
            singlePage: !0,
            settings: {},
            autoCycleTimer: null,
            dragging: !1,
            touchObject: {
              startX: 0,
              startY: 0,
              endX: 0,
              endY: 0,
              length: 0,
              direction: -1
            },
            scrollOnDeviceProps: {
              arrows: !1,
              dots: !1,
              lazyLoad: !1,
              autoCycle: !1
            },
            lowerBreakpoint: void 0,
            higherBreakpoint: void 0,
            slideUniqueIds: []
          }, h;
        }
        return e = r, (t = [{
          key: "componentDidMount",
          value: function value() {
            this.init(), window && (window.addEventListener ? window.addEventListener("resize", this.onWindowResized) : window.attachEvent("onresize", this.onWindowResized));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            window.addEventListener ? window.removeEventListener("resize", this.onWindowResized) : window.detachEvent("onresize", this.onWindowResized), (0, u.componentWillUnmount)();
            var e = this.state.autoCycleTimer;
            e && clearInterval(e);
          }
        }, {
          key: "render",
          value: function value() {
            var e,
              t,
              n,
              o = this.props,
              r = o.scrollOnDevice,
              i = o.pagingSeparator,
              s = o.name,
              a = r && A(),
              l = this.state,
              c = l.settings,
              u = l.singlePage,
              d = l.activePage,
              o = l.slidePages,
              l = l.dragging;
            !c.arrows || u || a || (t = null == c.prevArrow ? f().createElement(h, {
              carouselName: s,
              next: !1,
              onClick: this.moveToPrevious
            }) : (t = {
              onClick: this.moveToPrevious
            }, f().cloneElement(c.prevArrow, t)), n = null == c.nextArrow ? f().createElement(h, {
              carouselName: s,
              onClick: this.moveToNext
            }) : (n = {
              onClick: this.moveToNext
            }, f().cloneElement(c.nextArrow, n))), !c.dots || u || a || (e = f().createElement(m, {
              carouselName: s,
              activePage: d,
              numberOfDots: o,
              onClick: this.onDotClick
            })), !c.paging || u || a || (e = f().createElement("span", {
              "data-testid": "".concat(s, "-paging"),
              className: "InfiniteCarouselPaging"
            }, "".concat(d + 1, " ").concat(i, " ").concat(o)));
            var p,
              d = this.state,
              i = d.children,
              o = d.lazyLoadedList,
              d = d.visibleSlideList,
              o = this.getFormatedChildren(i, o, d),
              d = r && A() ? (p = C({}, this.getScrollTrackStyles), "InfiniteCarouselScrollTrack") : (p = C({}, this.getTrackStyles()), ""),
              r = r && A();
            return f().createElement("div", {
              id: s,
              "data-testid": s,
              className: "InfiniteCarousel",
              onFocus: this.onMouseOver,
              onMouseEnter: this.onMouseEnter,
              onMouseLeave: this.onMouseLeave,
              onMouseOver: this.onMouseOver
            }, t, f().createElement("div", {
              className: "InfiniteCarouselFrame",
              ref: this.storeFrameRef
            }, f().createElement("ul", {
              className: d,
              style: p,
              onMouseDown: r ? null : this.onSwipeStart,
              onMouseLeave: l && !r ? this.onSwipeEnd : null,
              onMouseMove: l && !r ? this.onSwipeMove : null,
              onMouseUp: r ? null : this.onSwipeEnd,
              onTouchCancel: l && !r ? this.onSwipeEnd : null,
              onTouchEnd: r ? null : this.onSwipeEnd,
              onTouchMove: l && !r ? this.onSwipeMove : null,
              onTouchStart: r ? null : this.onSwipeStart
            }, o)), n, e);
          }
        }]) && w(e.prototype, t), n && w(e, n), r;
      }();
      o.propTypes = {
        children: t().oneOfType([t().arrayOf(t().node), t().node]),
        name: t().string,
        arrows: t().bool,
        dots: t().bool,
        paging: t().bool,
        pagingSeparator: t().string,
        lazyLoad: t().bool,
        swipe: t().bool,
        draggable: t().bool,
        animationDuration: t().number,
        slidesToShow: t().number,
        slidesToScroll: t().number,
        slidesSpacing: t().number,
        autoCycle: t().bool,
        cycleInterval: t().number,
        pauseOnHover: t().bool,
        breakpoints: t().arrayOf(t().object),
        placeholderImageSrc: t().string,
        nextArrow: t().element,
        prevArrow: t().element,
        scrollOnDevice: t().bool,
        showSides: t().bool,
        sidesOpacity: t().number,
        sideSize: t().number,
        incrementalSides: t().bool,
        onSlideChange: t().func,
        onNextClick: t().func,
        onPreviousClick: t().func
      }, o.defaultProps = {
        children: [],
        name: "infinite-carousel",
        arrows: !0,
        dots: !1,
        paging: !1,
        lazyLoad: !1,
        swipe: !0,
        draggable: !1,
        animationDuration: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        slidesSpacing: 10,
        autoCycle: !1,
        cycleInterval: 5e3,
        pauseOnHover: !0,
        breakpoints: [],
        placeholderImageSrc: "",
        pagingSeparator: "/",
        nextArrow: null,
        prevArrow: null,
        scrollOnDevice: !1,
        showSides: !1,
        sidesOpacity: 1,
        sideSize: .5,
        incrementalSides: !1,
        onSlideChange: void 0,
        onNextClick: void 0,
        onPreviousClick: void 0
      };
      var I = o;
    }(), k;
  }();
});